export const JOB_CALLOUT_ICONS = [
  'bell',
  'search',
  'e-mail',
  'service',
  'phone',
  'disorder',
  'service-v2',
] as const;
